import { EAppModule } from "dto/EAppModule";
import { IMemberAccess } from "dto/Access/IMemberAccess";
import { create } from "zustand";

interface IPrivilegesState {
  active: string;
  /** Moduły pakietu (dto/EAppModule) z /ui/privileges. */
  privileges: string[];
  /**
   * Funkcje aplikacji (dto/EAppFunction) z /ui/privileges — scalenie pakietu z metryką
   * pracownika. undefined = jeszcze nie wczytano (CASL nie pokazuje żadnej funkcji);
   * null = nieznane (błąd żądania albo starszy BE bez pola Functions): wtedy CASL nie
   * ogranicza ról, tylko pakiet (contexts/AbilityContext).
   */
  functions: string[] | null | undefined;
  /** Metryka pracownika w modelu Magistratu (rola, prawo miejscowe, widok budżetu…). */
  access: IMemberAccess | null;
  /**
   * Instancja z płatnościami (BE Payments:Enabled). false = wszyscy Premium, bez limitu
   * miejsca — bez zakładki „Płatności". Domyślnie true (do czasu wczytania /ui/privileges).
   */
  paymentsEnabled: boolean;
  loaded: boolean;
  init: (
    modules: string[],
    functions?: string[] | null,
    access?: IMemberAccess | null,
    paymentsEnabled?: boolean,
  ) => void;
  switchToFree: () => void;
  swtichToStandard: () => void;
  swtichToPremium: () => void;
  toggleModule: (module: EAppModule) => void;
}

const usePrivilegesStore = create<IPrivilegesState>()((set) => ({
  active: "free",
  privileges: [],
  functions: undefined,
  access: null,
  paymentsEnabled: true,
  loaded: false,
  init: (modules, functions = null, access = null, paymentsEnabled = true) => {
    set(() => ({
      privileges: modules,
      functions: Array.isArray(functions) ? functions : null,
      access,
      paymentsEnabled,
      loaded: true,
    }));
    console.log("Privileges initialized", modules, functions);
  },

  switchToFree: () => {
    set(() => ({
      active: "free",
      privileges: [
        EAppModule.Incoming,
        EAppModule.Outgoing,
        EAppModule.AddressBook,
        EAppModule.Desk,
      ],
    }));
  },

  swtichToStandard: () => {
    set(() => ({
      active: "standard",
      privileges: [
        EAppModule.Incoming,
        EAppModule.Outgoing,
        EAppModule.AddressBook,
        EAppModule.Desk,
        EAppModule.Cases,

        EAppModule.Drive,
        EAppModule.Word,
        EAppModule.Notes,
      ],
    }));
  },

  swtichToPremium: () => {
    set(() => ({
      active: "premium",
      privileges: [
        EAppModule.Incoming,
        EAppModule.Outgoing,
        EAppModule.AddressBook,
        EAppModule.Desk,
        EAppModule.Cases,
        EAppModule.Drive,
        EAppModule.Word,
        EAppModule.Notes,

        EAppModule.EncryptedParcels,
        EAppModule.WordExt,
        EAppModule.Tasks,
        EAppModule.Workspace,
        EAppModule.CourtPortal,
      ],
    }));
  },

  toggleModule: (module: EAppModule) => {
    set((state) => {
      let currentPrivileges: string[] = state.privileges;

      if (currentPrivileges.find((x) => x === module)) {
        currentPrivileges = currentPrivileges.filter((x) => x !== module);
      } else {
        currentPrivileges = [...currentPrivileges, module];
      }

      return {
        privileges: currentPrivileges,
      };
    });
  },
}));

export default usePrivilegesStore;
